'use client'

import { blockNumber } from '@utils'
import classNames from 'classnames'
import { useCallback } from 'react'
import { useBoolean } from 'react-use'

export default function OfficePhoneButton({
  data,
  className,
  icon = false,
  full = true,
  children
}) {
  const [displayPhone, togglePhone] = useBoolean(false)
  const showPhone = useCallback(() => togglePhone(true), [togglePhone])

  return data.phoneNumber && (
    <a href={`tel:${data.phoneNumber}`} className={classNames('button-primary-out', { 'w-full': full }, { 'px-20 justify-between': icon }, className)} onClick={showPhone} data-noprogress>
      {icon && <i className='icon icon-phone'></i>}
      <span className={classNames({ 'flex-1 text-center': icon })}>
        {
          children
            ? children
            : displayPhone ? data.phoneNumber : blockNumber(data.phoneNumber)
        }
      </span>
    </a>
  )
}